import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { setApiKeyHeader } from '../utilities/set-api-key-header';
/**
 * @internal
 */
export var fetchGetProductCatalogue = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var options;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                options = {};
                setApiKeyHeader(options);
                return [4 /*yield*/, fetchGet(url, options)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
